import Audio from '~/Audio';
import Colors from '~/constants/Colors';
import { logError } from '~/logger';
import text from '~/text';
import { GraphQlRequestError } from '~/graphql/graphqlClient';
import { ItemLocationInput } from 'dt-common/generated/graphql-types';
import messages, { GameStateStoreMessage } from '~/flux/stores/GameStateStore/messages';
import mutationPlaceItemInGlobalInventory from '~/graphql/game-items/mutationPlaceItemInGlobalInventory';

export default async function placeItemInGlobalInventory(
  {
    playerId,
    setInventoryAndHeroRoster,
    emit,
  }: {
    playerId: string;
    setInventoryAndHeroRoster: (data: { inventory?: unknown; hero_roster?: unknown }) => void;
    emit: (event: GameStateStoreMessage) => void;
  },
  action: { game_item: { uid: string }; from: ItemLocationInput; to: ItemLocationInput }
) {
  try {
    const data = await mutationPlaceItemInGlobalInventory({
      playerId,
      itemId: action.game_item.uid,
      from: action.from,
      to: action.to,
    });

    setInventoryAndHeroRoster({
      ...(data.inventory != null && { inventory: data.inventory }),
      ...(data.heroRoster != null && { hero_roster: data.heroRoster }),
    });

    emit(messages.EQUIPMENT_CHANGE);
    Audio.play('equipment_storage');
  } catch (err) {
    const errorKey = err instanceof GraphQlRequestError ? err.errors?.[0]?.message : undefined;
    if (typeof errorKey === 'string' && text(errorKey)) {
      window.$addMessageLogMessage(text(errorKey), Colors.RED);
    } else {
      window.$addMessageLogMessage(text('server_error'), Colors.RED);
      logError(err, {
        module: 'GameStateStore',
        func: 'placeItemInGlobalInventory',
        playerId,
        action: JSON.stringify(action),
      });
    }
  }
}
